import store from 'store2';
import moment from 'moment';
import constants from './constants';

const clearStateIfNeeded = () => {
  const timestamp = store(constants.SURVEY_EXPIRATION_NAME);
  let shouldClear = true;

  if (timestamp < 0) {
    shouldClear = false;
  } else if (timestamp && moment().isBefore(moment(parseInt(timestamp, 10)))) {
    shouldClear = false;
  }

  if (shouldClear) {
    store.remove(constants.SURVEY_STATE_NAME);
  }
};

export default clearStateIfNeeded;



// WEBPACK FOOTER //
// ./src/components/SurveyToast/businessLogics/clearStateIfNeeded.js